import instagram from "./icons/instagram.svg";
import envelope from "./icons/envelope.svg";
import facebook from "./icons/facebook.svg";
import linkedin from "./icons/linkedin.svg";
import messenger from "./icons/messenger.svg";
import snapchat from "./icons/snapchat.svg";
import telegram from "./icons/telegram.svg";
import threadsFill from "./icons/threads-fill.svg";
import viber from "./icons/viber 1.svg";
import whatsapp from "./icons/whatsapp.svg";
import xIcon from "./icons/x.svg";
import pinterest from "./icons/pinterest.svg";

export const SHARE_SOCIALS = [
  {
    icon: instagram,
    text: "Share on Instagram",
    shareLink: "https://www.instagram.com/?url=",
  },
  {
    icon: threadsFill,
    text: "Share on Threads",
    shareLink: "https://www.threads.net/share?url=",
  },
  {
    icon: facebook,
    text: "Share on Facebook",
    shareLink: "https://www.facebook.com/sharer/sharer.php?u=",
  },
  {
    icon: telegram,
    text: "Share via Telegram",
    shareLink: "https://t.me/share/url?url=",
  },
  {
    icon: linkedin,
    text: "Share on LinkedIn",
    shareLink: "https://www.linkedin.com/sharing/share-offsite/?url=",
  },
  {
    icon: messenger,
    text: "Share via Messenger",
    shareLink: "fb-messenger://share?link=",
  },
  {
    icon: xIcon,
    text: "Share on X (Twitter)",
    shareLink: "https://twitter.com/intent/tweet?url=",
  },
  {
    icon: viber,
    text: "Share via Viber",
    shareLink: "viber://forward?text=",
  },
  {
    icon: snapchat,
    text: "Share on Snapchat",
    shareLink: "https://www.snapchat.com/scan?attachmentUrl=",
  },
  {
    icon: whatsapp,
    text: "Share via WhatsApp",
    shareLink: "https://wa.me/?text=",
  },
  {
    icon: pinterest,
    text: "Share on Pinterest",
    shareLink: "https://pinterest.com/pin/create/button/?url=",
  },
  {
    icon: envelope,
    text: "Share via Email",
    shareLink: "mailto:?body=",
  },
];
